import React from "react";

const TimeRangePanel = ({
    ranges,
    activeRange,
    startTime,
    endTime,
    loading,
    error,
    onQuickRange,
    onStartChange,
    onEndChange,
    onFetch,
    hidden,
}) => (
    <section
        className="graph-page__card"
        role="tabpanel"
        id="history-panel-range"
        aria-labelledby="history-tab-range"
        hidden={hidden}
    >
        <div className="graph-page__card-head">
            <h2 id="history-range-heading">Time range</h2>
            <p>Quick ranges fill the start and end fields. Fetch Data loads that interval and does not start live polling.</p>
        </div>
        <div className="graph-page__ranges" role="group" aria-label="Quick time ranges">
            {ranges.map((range) => (
                <button
                    key={range.id}
                    type="button"
                    className={`graph-page__chip${activeRange === range.id ? " is-active" : ""}`}
                    onClick={() => onQuickRange(range.id)}
                >
                    {range.label}
                </button>
            ))}
        </div>
        <div className="graph-page__range-grid">
            <div className="graph-page__field">
                <label htmlFor="history-start">Start Time</label>
                <input id="history-start" type="datetime-local" value={startTime} onChange={(event) => onStartChange(event.target.value)} />
            </div>
            <div className="graph-page__field">
                <label htmlFor="history-end">End Time</label>
                <input id="history-end" type="datetime-local" value={endTime} onChange={(event) => onEndChange(event.target.value)} />
            </div>
        </div>
        <div className="graph-page__actions">
            <button type="button" className="graph-page__button graph-page__button--primary" onClick={onFetch} disabled={loading}>
                {loading ? "Fetching…" : "Fetch Data"}
            </button>
        </div>
        {error && <p className="graph-page__banner is-error" role="alert">{error}</p>}
        {loading && <p className="graph-page__empty">Loading history…</p>}
    </section>
);

export default TimeRangePanel;
